import ApiClient from '../../utils/api/ApiClient'
import type { SSOClientConfig } from './types'

/**
 * Fetches an SSO client config from the BFF registry (sso_client table).
 * Returns null when the client is unknown or the request fails.
 */
export const fetchSSOClientConfig = async (clientName: string): Promise<SSOClientConfig | null> => {
  try {
    const { data } = await ApiClient.get(`/sso-clients/${encodeURIComponent(clientName)}`)
    if (typeof data?.clientName !== 'string' || typeof data?.clientId !== 'string') return null
    return data as SSOClientConfig
  } catch {
    return null
  }
}
